import { render, staticRenderFns } from "./invtSelect.vue?vue&type=template&id=19527294&scoped=true"
import script from "./invtSelect.vue?vue&type=script&lang=js"
export * from "./invtSelect.vue?vue&type=script&lang=js"
import style0 from "./invtSelect.vue?vue&type=style&index=0&id=19527294&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19527294",
  null
  
)

export default component.exports